import React, { useState } from 'react';
import { Icons, IconButton } from "@curves/ui-base";
import MemberSiteQrCodeDialog from '@icoach/components/dialog/MemberSiteQrCodeDialog';

const MeasureInformationBox = (props) => {
    const { sourceData = {} } = props;
    const [open, setOpen] = useState(false);

    const handleOnClose = () => {
        setOpen(false);
    };

    const handleOnClick = () => {
        setOpen(true);
    };

    return (
        <React.Fragment>
            <MemberSiteQrCodeDialog open={open} onClose={handleOnClose} sourceData={{ referenceID: sourceData.memberID }} />
            <IconButton onClick={handleOnClick}>
                <Icons.QrCode />
            </IconButton>
        </React.Fragment>
    );
};

export default MeasureInformationBox;
